import { render, staticRenderFns } from "./bookedVehiclesTable.vue?vue&type=template&id=5fedff74"
import script from "./bookedVehiclesTable.vue?vue&type=script&lang=js"
export * from "./bookedVehiclesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports